import { get, put } from '@api/request';

export const fetchOfficeInfo = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/clientinformation`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateOfficeInfo = async (
  { appraisalService },
  authenticationToken,
  payload,
) => {
  const url = `${appraisalService}/appraisal/clientinformation`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};
